// ═══════════════════════════════════════════════════════════════════════════
// VARIANTI → BUDGET DELLA COMMESSA (ottobre 2026)
// ═══════════════════════════════════════════════════════════════════════════
// Il riepilogo delle varianti (utils/varianti.js) si salva sul budget della commessa nel
// campo variantiCalcolate, come già si fa con costiCalcolati: così Cabina di Regia, Insight,
// Centro Operativo, report e registri leggono tutti lo STESSO totale commessa senza dover
// caricare le varianti. Si chiama dopo ogni modifica di una variante.
// Il budget originale (importoCommessa) NON viene mai toccato.
// Se la commessa non ha ancora un budget, se ne crea uno con un nome fisso
// (budget_<idCommessa>): due salvataggi contemporanei finiscono sullo stesso documento,
// mai due budget per la stessa commessa.
// ═══════════════════════════════════════════════════════════════════════════
import { collection, query, where, getDocs, doc, updateDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { riepilogoVarianti, stessoRiepilogo } from "./varianti";

export async function sincronizzaVariantiSuBudget(projectId, orgId) {
  if (!projectId || !orgId) return null;
  const [varSnap, budSnap] = await Promise.all([
    getDocs(query(collection(db, "attivitaExtra"), where("projectId", "==", projectId), where("orgId", "==", orgId))),
    getDocs(query(collection(db, "budgetCommessa"), where("projectId", "==", projectId), where("organizationId", "==", orgId))),
  ]);
  const r = riepilogoVarianti(varSnap.docs.map(d => d.data()));
  if (!budSnap.empty) {
    const b = budSnap.docs[0];
    if (stessoRiepilogo(b.data().variantiCalcolate, r)) return r;
    await updateDoc(doc(db, "budgetCommessa", b.id), { variantiCalcolate: { ...r, aggiornatiIl: serverTimestamp() } });
    return r;
  }
  if (r.n === 0) return r; // nessuna variante e nessun budget: niente da scrivere
  await setDoc(doc(db, "budgetCommessa", "budget_" + projectId), {
    // solo i campi delle varianti: se nello stesso istante qualcuno salva il budget sullo
    // stesso documento, il merge non gli azzera l'importo contrattuale
    projectId, organizationId: orgId,
    variantiCalcolate: { ...r, aggiornatiIl: serverTimestamp() },
  }, { merge: true });
  return r;
}
